'use strict';

export default class MemTypeListCtrl {
  constructor($stateParams, $location, LoaderSvc, MemTypeSvc, GroupAuthSvc) {
    LoaderSvc.start('Loading Member Types...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = groupId;

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberType', 'I');

    // default filter
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    that.dataModel = 'mtvm';
    MemTypeSvc.getDefinedFor({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'name';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() { LoaderSvc.stopError('Error loading member types'); });
  }
}

MemTypeListCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'MemTypeSvc',
  'GroupAuthSvc'
];
